import { render, staticRenderFns } from "./contactMinSpendWidget.vue?vue&type=template&id=9eeff328&"
import script from "./contactMinSpendWidget.vue?vue&type=script&lang=js&"
export * from "./contactMinSpendWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports